import { render, staticRenderFns } from "./button-pure.code.md?vue&type=template&id=47512d7c&"
import script from "./button-pure.code.md?vue&type=script&lang=ts&"
export * from "./button-pure.code.md?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../storefront/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports